import React, { useState, useMemo } from 'react'
import { useSelector } from 'react-redux'

import {
  Grid, Card, CardContent,
  Tabs, Tab, AppBar
} from '@material-ui/core'

import { makeStyles, withStyles } from '@material-ui/core/styles'

import { TabPanel } from '../../../tools'

import { CiscoRequests, CiscoLists } from '.'

import { parseUnitInfo } from '../../../../../utils'

const learnsafeGreen = '#A4D164'
const learnsafeBlue = '#5291fc'

const StyledTabs = withStyles({
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    backgroundColor: 'transparent',
    '& > span': {
      maxWidth: 60,
      width: '100%',
      backgroundColor: learnsafeBlue
    }
  }
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />)

const useStyles = makeStyles((theme) => ({
  tabBar: {
    backgroundColor: learnsafeGreen
  }
}))

// const StyledCheckBox = withStyles((theme) => ({
//   root: {
//     color: theme.palette.warning.light,
//     '&$checked': {
//       color: theme.palette.warning.light
//     }
//   },
//   checked: {}
// }))((props) => <Checkbox color='default' {...props} />)

const CiscoUmbrella = () => {
  const classes = useStyles()

  const TreeData = useSelector(state => state.auth.unitTree)

  const [tabValue, setTabValue] = useState('requests')
  const [unitDisplays, setUnitDisplays] = useState([])

  useMemo(() => { if (TreeData) { setUnitDisplays(parseUnitInfo(TreeData)) } }, [TreeData])

  const a11yProps = (tabValue) => {
    return {
      id: `simple-tab-${tabValue}`,
      'aria-controls': `simple-tabpanel-${tabValue}`
    }
  }

  return (
    <Grid container direction='row'>
      <Grid item container direction='column' justify='flex-start' spacing={2} className='mx-auto w-100'>
        <Grid container item direction='row'>
          <Grid item>
            <h2>Cisco Umbrella</h2>
          </Grid>
        </Grid>

        <Grid container item direction='row'>
          <Grid item xs={12}>
            <Card raised elevation={3}>
              <AppBar position='relative' className={classes.tabBar}>
                <Grid container direction='row'>
                  <Grid item xs={12}>
                    <StyledTabs
                      value={tabValue}
                      centered
                      onChange={(e, newTab) => setTabValue(newTab)}
                    >
                      <Tab className='font-weight-bold' label='Block Requests' value='requests' {...a11yProps('requests')} />
                      <Tab className='font-weight-bold' label='Destination Lists' value='lists' {...a11yProps('lists')} />
                    </StyledTabs>
                  </Grid>
                </Grid>
              </AppBar>

              <CardContent>
                <TabPanel index='requests' value={tabValue}>
                  <CiscoRequests unitDisplays={unitDisplays} />
                </TabPanel>

                <TabPanel index='lists' value={tabValue}>
                  <CiscoLists unitDisplays={unitDisplays} />
                </TabPanel>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CiscoUmbrella
